import { useParams } from 'react-router';

import type { HorizonAppRouteLoaderArgs } from 'routing/classes/types/AppRouteLoaderArgs';
import type { viewCmsFileRoute } from 'routing/routes';
import type { HorizonAppRouteComponentProps } from 'routing/types/HorizonAppRouteComponentProps';

import { ViewPdfFilePageLoadable } from './ViewPdfFilePageLoadable';

export async function loader({}: HorizonAppRouteLoaderArgs<
  typeof viewCmsFileRoute
>) {
  await ViewPdfFilePageLoadable.load();
  return {};
}

export default function ViewPdfFileHorizonRoute({
  loaderData: {},
}: HorizonAppRouteComponentProps<typeof loader>) {
  const { '*': filename } = useParams();
  return <ViewPdfFilePageLoadable filename={filename!} />;
}
